const wordBreak = {
  name: "word-break",
  path: "/word-break",
  title: "Word Break",
  description: "Utilities for controlling how words should break within an element.",
  value: {
    "word-break": {
      "break-normal": "normal",
      "break-all": "break-all",
      "keep-all": "keep-all"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="break-normal w-48">Thequickbrownfoxjumpsoverthelazydog The quick brown fox jumps over the lazy dog.</p>
<p class="break-all w-48">Thequickbrownfoxjumpsoverthelazydog The quick brown fox jumps over the lazy dog.</p>
<p class="keep-all w-48">Thequickbrownfoxjumpsoverthelazydog The quick brown fox jumps over the lazy dog.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">break-normal</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">break-all</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">keep-all</code> to control word breaking.
      </p>
      <div class="space-y-6 max-w-xs">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">break-normal</small>
          <p class="break-normal w-48 border border-color-gray-200 p-4">Thequickbrownfoxjumpsoverthelazydog The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">break-all</small>
          <p class="break-all w-48 border border-color-gray-200 p-4">Thequickbrownfoxjumpsoverthelazydog The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">keep-all</small>
          <p class="keep-all w-48 border border-color-gray-200 p-4">Thequickbrownfoxjumpsoverthelazydog The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default wordBreak;
<div className="break-normal break-all keep-all sr-only"></div>